import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { AppScope, ResourceService, ResourceTag } from '@klickdata/core/resource';
import { TagService } from '@klickdata/core/resource/src/tag/tag.service';
import { ResourceListingSheetComponent } from '@klickdata/shared-components/src/resource-listing-sheet/resource-listing-sheet.component';
import { Observable } from 'rxjs';
import { ResourceItemDirective } from '../resource-item.directive';

@Component({
    selector: 'app-resource-builder-event',
    templateUrl: './resource-builder-event.component.html',
    styleUrls: ['./resource-builder-event.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceBuilderEventComponent extends ResourceItemDirective {
    public resourceTags: Observable<ResourceTag[]>;
    constructor(
        protected resourceService: ResourceService,
        protected changeRef: ChangeDetectorRef,
        protected tagService: TagService,
        protected bottomSheet: MatBottomSheet,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected mobileService: MobileService
    ) {
        super(resourceService, changeRef, dialog, authService, mobileService, bottomSheet);
    }

    protected afterResourceInit() {
        this.resourceTags = this.tagService.getResourceTags(this.selected.id);
    }

    public showTagResources(tag: ResourceTag) {
        this.bottomSheet.open(ResourceListingSheetComponent, {
            data: {
                id: tag.id,
                label: tag.name,
                scope_id: AppScope.TAGS,
            },
            panelClass: 'sheet-wrapper',
        });
    }
}
